/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import "./houseCardsBlock.css";
import "./responsive.css";
import { HouseCard, Pagination } from "../../components/index.js";
import axios from "axios";
import { isUserLoginFunc, toObjFilterConverter } from "../../constants/methods";
import { InView } from "react-intersection-observer";
const stringBoolean = ["true", "1", "yes"];
const HouseCardsBlock = ({ isHistory, container, isPicturesFeature }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [data, setData] = useState(null);
  const [dataError, setDataError] = useState(null);
  const [heardData, setHeardData] = useState([{ id: null, value: 4 }]);
  const [isUserLogin, setIsUserLogin] = useState(null);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
  };

  const dataSourceUrl = container.getAttribute("data-source-url");

  const dataLimit = container.getAttribute("data-limit");
  const dataSourceParam = container.getAttribute("data-source-param");
  const dataSubdomainParam = container.getAttribute("data-subdomain");
  const dataSourceTitle = container.getAttribute("data-source-title");
  const dataHearthIcon = container.getAttribute("data-hearth-icon");
  const dataFilters = container.getAttribute("data-filters");
  const isDataFilters = stringBoolean.includes(dataFilters);
  const dataSourceUrlPostRaw = container.getAttribute("data-source-url-post"); //"true" || nothing
  const dataSourceUrlPost = stringBoolean.includes(dataSourceUrlPostRaw); //"true" || nothing
  const dataOrderBy = container.getAttribute("data-order-by");

  const dataPagination = container.getAttribute("data-pagination");

  const setDataEvent = (value) => {
    let customEvent = new CustomEvent("ListingGlanceDataLoadedEvent", {
      detail: { data: value },
    });

    // Dispatch the custom event on a specific element or the document
    document.dispatchEvent(customEvent);
  };

  useEffect(() => {

    if (!isDataFilters) {
      const url = `${dataSourceUrl}?page=${currentPage + 1}&limit=${dataLimit || 3}&pagination=${dataPagination || "false"}${
        dataSourceParam ? `&${dataSourceParam}` : ""
      }${dataSubdomainParam ? "&Subdomain=" + dataSubdomainParam : ""}`;

      const requestMethod = dataSourceUrlPost ? axios.post : axios.get;

      requestMethod(url)
        .then(function (response) {
          setData(response.data);
          setDataEvent(response.data);
        })
        .catch(function (error) {
          setDataError(error);
          console.log(error, "AXIOS ERROR");
        });
    } else {
      // const isUserLoginedValue = isUserLoginFunc();
      // console.log(JSON.parse(dataFilters), "dataFilters");
      axios
        .post(
          dataSourceUrlPost
            ? `${dataSourceUrl}?page=${currentPage + 1}&limit=${
                dataLimit ? dataLimit : 3
              }&pagination=${dataPagination ? dataPagination : "false"}${
                dataSourceParam ? `&${dataSourceParam}` : ""
              }${dataSubdomainParam ? "&Subdomain=" + dataSubdomainParam : ""}`
            : `https://api.realtytexas.net/v2/listings`,
          {
            top: dataLimit ? dataLimit : 3,
            count: "true",
            maxPrice: 5000000,
            minPrice: 0,
            filters:
              dataFilters != "true"
                ? toObjFilterConverter(JSON.parse(dataFilters))
                : [],
            //select: ["ListingKeyNumeric", "PropertyType"],
            page: currentPage + 1,
            orderby: dataOrderBy ? `rtlist desc,${dataOrderBy}` : "rtlist desc",
          }
        )
        .then(function (response) {
          setData({ data: response.data.data.listings });
          //   console.log(response.data.data.listings,'postData')
          setDataEvent({ data: response.data.data.listings });
        })
        .catch(function (error) {
          console.log(error, "all cards error");
        });
    }
  }, [currentPage]);

  // function userLoginHandler() {
  //   const myRTP = window.localStorage.getItem("MyRTP");
  //   if (myRTP !== null) {
  //     setIsUserLogin(true);
  //   } else setIsUserLogin(false);
  // }

  // document.addEventListener("RTUserLoginEvent", userLoginHandler);

  // useEffect(() => {
  //   userLoginHandler();
  // }, []);

  const getUserHeardList = () => {
    const myRTP = JSON.parse(localStorage?.getItem("MyRTP"));
    const listingInteractions = JSON?.parse(
      localStorage?.getItem("listingInteractions")
    );

    if (myRTP?.SubjectID) {
      if (listingInteractions?.listings) {
        setHeardData([
          ...listingInteractions?.listings.map((item) => {
            return { id: isHistory ? +item.id : item.id, value: item.value };
          }),
        ]);
      } else {
        setHeardData([{ id: null, value: 4 }]);
      }
      // axios
      //   .get(
      //     `https://web.realtytexas.io/api/v1/clients/identity/${myRTP.SubjectID}/listings/interactions`
      //   )
      //   .then(function (response) {
      //     setHeardData([
      //       ...response?.data?.data.map((item) => {
      //         return { id: +item.id, value: item.value };
      //       }),
      //     ]);
      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //   });
    }
  };

  useEffect(() => {
    const myRTP = JSON?.parse(localStorage?.getItem("MyRTP"));
    if (myRTP?.SubjectID) {
      getUserHeardList();
    }
  }, []);

  const handleRTLoginEvent = () => {
    setIsUserLogin(true);
    getUserHeardList();
    // console.log("RTLoginEvent2 RTLoginEvent2 RTLoginEvent2");
  };

  useEffect(() => {
    document.addEventListener("RTLoginEvent", handleRTLoginEvent);
    return () => {
      document.removeEventListener("RTLoginEvent", handleRTLoginEvent);
    };
  }, []);

  return (
    <>
      <div className="active-listings-house-cards-block-title">
        <h4>{dataSourceTitle}</h4>
      </div>
      <div className="active-listings-house-cards-block-wrapper">
        <div className="active-listings-house-cards-block">
          {data &&
            data.data &&
            data?.data?.map((item, i) => {
              return (
                <InView key={i}>
                  {({ inView, ref }) => (
                    <HouseCard
                      inView={inView}
                      rootRef={ref}
                      key={i}
                      item={item}
                      currentPage={currentPage}
                      heardData={heardData}
                      setHeardData={setHeardData}
                      listingsData={data}
                      isUserLogin={isUserLogin}
                      isHistory={isHistory}
                      container={container}
                      picturesFeature={isPicturesFeature}
                      ind={i}
                    />
                  )}
                </InView>
              );
            })}
        </div>

        {dataPagination !== "false" &&
          data &&
          data?.data &&
          data.data.length > 0 &&
          data?.meta?.pagination?.total_pages > 1 && (
            <Pagination
              initialPage={0}
              pageRangeDisplayed={3}
              marginPagesDisplayed={1}
              pageCount={data?.meta?.pagination?.total_pages}
              onPageChange={handlePageClick}
              currentPage={currentPage}
            />
          )}
        {/* {data !== null && visibleHouseCards?.length === 0 && (
          <div>No Data Found...</div>
        )} */}
      </div>
    </>
  );
};

export default HouseCardsBlock;
